<template>
  <accounts-component-template
    component-name="Email Preferences"
    component-key="email-preferences"
    color="#666">
    <template v-slot:icon>
      <email-icon :size="16" />
    </template>
    <template v-slot:content>
      <div class="account-details-formfield">
        <!-- @TODO - disabled for now -->
        <!-- <div class="account-details-checkboxfield">
          <input type="checkbox" />
          <span>Send a copy of all email notifications to the following email addresses:</span>
        </div> -->

        <div class='margin-bt-18' :class="{'fieldset-disabled': emailForwardingOff}">
          <label class="account-details-checkboxfield">
            <input type="checkbox" :checked="!emailForwardingOff" @input="toggleEmailForwardingOff" />
            <span>Send a copy of all email notifications to the following email addresses:</span>
          </label>
        </div>

        <div class="account-details-fieldset">
          <div v-if="!emailPreferences.emails.length">
            <span style="color:#e6324b">Add an email address first, then select CC or BCC</span>
          </div>
          <multiselect
            id="email_prefs_emails"
            :value="emailPreferences.emails"
            placeholder="Type Email and press enter to select"
            tag-placeholder="Press enter to add email"
            autocomplete="off"
            name="prefs"
            class="co-custom-arrow account-details-multiselect"
            :options="forwardingEmailOptions"
            :multiple="true"
            :taggable="true"
            @remove="onRemove"
            @tag="onForwardEmail">
            <span slot="noResult">No results found</span>
            <template slot="caret" slot-scope="{toggle}" :toggle="toggle">
              <chevron-down-icon title="emails" :size="24" @mousedown.prevent.stop="toggle()" class="multiselect__select" />
            </template>
          </multiselect>

          <div>
            <label class="account-details-radiofield" style="display: inline-block;" :class="{'fieldset-disabled': emailForwardingOff}" @click="setCCType('cc')">
                <input :disabled="emailForwardingOff" type="radio" name="method" :checked="emailPreferences.method == 'cc'" value="cc" />
                <span>Use CC</span>
            </label>
          </div>

          <div>
            <label class="account-details-radiofield" :class="{'fieldset-disabled': emailForwardingOff}" style="display: inline-block;" @click="setCCType('bcc')">
                <input :disabled="emailForwardingOff" type="radio" name="method" :checked="emailPreferences.method == 'bcc'" value="bcc" />
                <span>Use BCC</span>
            </label>
        </div>
        </div>
      </div>
    </template>
  </accounts-component-template>
</template>

<script>
import Vue from 'vue';
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import {EmailIcon, ChevronDownIcon} from '../icons';
import EmailValidator from 'email-validator';
import {mapActions, mapGetters} from 'vuex';

function failureNotification (title, message) {
    Vue.notify({
        group: 'admin:account:details',
        title: title,
        text: message,
        type: 'error',
        duration: 3000,
        speed: 500
    });
}

export default {

  props: {},

  components: {
    AccountsComponentTemplate,
    EmailIcon,
    ChevronDownIcon,
  },

  data () {
    return {

      emailsToNotify: [],

      forwardingEmailOptions: [],

      ccType: ''
    }
  },

  updated () {
    this.autocompleteHack();
  },

  mounted () {
    this.autocompleteHack();
  },

  computed: {

      ...mapGetters('AdminAccountDetailsStore', [
          'accountId',
          'account',
          'emailPreferences'
      ]),

      emailForwardingOff () {
        return this.emailPreferences.method == 'off';
      }
  },

  methods: {

    ...mapActions('AdminAccountDetailsStore', [
        'updateEmailPreferences',
        'addForwardingEmail',
        'removeForwardingEmail'
    ]),

    update (emails, method) {
        this.updateEmailPreferences({
            emails,
            method,
            accountId: this.accountId
        }).then(result => {
            console.log('email prefs update', result);
            if (result.error) {
               //show some error
               console.error('update email prefs error');
            }
        })
    },

    toggleEmailForwardingOff () {
      if (this.emailForwardingOff) {
        this.setCCType('cc');
      } else {
        this.setCCType('off');
      }
    },

    setCCType (ccType) {
        const {emails, method} = this.emailPreferences;

        this.update(emails, ccType);
    },

    onRemove (email) {
      this.removeForwardingEmail(email);

      this.$nextTick(() => {
          const {emails, method} = this.emailPreferences;

          this.update(emails, method);
      })
    },

    onForwardEmail (email) {
      if (!EmailValidator.validate(email)) {
          failureNotification('Update Failed', 'Email is invalid')
          return console.error('invalid email', email);
      }

      this.addForwardingEmail(email);

      console.log('adding forwarding', email)

      setTimeout(() => {
        const {emails, method} = this.emailPreferences;

        let setMethod = method;

        //turn email forwarding on
        if (method == 'off') setMethod = 'cc';

        this.update(emails, setMethod);
      },200);
    },

    //disable autocomplete in safari/Firefox
    autocompleteHack () {
      $('#email_prefs_emails').attr('autocomplete', 'off');
    }
  }
}
</script>

<style>
.margin-bt-18 {
  margin-bottom: 18px;
}
</style>
